"use strict";
/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
//==============================================================
// START Enums and Input Objects
//==============================================================
var ChannelMediaSource;
(function (ChannelMediaSource) {
    ChannelMediaSource["MEDIA_PLATFORM"] = "MEDIA_PLATFORM";
    ChannelMediaSource["PRIVATE_MEDIA"] = "PRIVATE_MEDIA";
    ChannelMediaSource["YOUTUBE"] = "YOUTUBE";
})(ChannelMediaSource = exports.ChannelMediaSource || (exports.ChannelMediaSource = {}));
var ChannelPricingType;
(function (ChannelPricingType) {
    ChannelPricingType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(ChannelPricingType = exports.ChannelPricingType || (exports.ChannelPricingType = {}));
var ChannelSource;
(function (ChannelSource) {
    ChannelSource["INTERNAL"] = "INTERNAL";
    ChannelSource["YOUTUBE"] = "YOUTUBE";
})(ChannelSource = exports.ChannelSource || (exports.ChannelSource = {}));
var ChannelUploadType;
(function (ChannelUploadType) {
    ChannelUploadType["COVER"] = "COVER";
    ChannelUploadType["TRAILER"] = "TRAILER";
})(ChannelUploadType = exports.ChannelUploadType || (exports.ChannelUploadType = {}));
var EntitiesSortingOrder;
(function (EntitiesSortingOrder) {
    EntitiesSortingOrder["CUSTOM_ASC"] = "CUSTOM_ASC";
    EntitiesSortingOrder["CUSTOM_DESC"] = "CUSTOM_DESC";
    EntitiesSortingOrder["TITLE_ASC"] = "TITLE_ASC";
    EntitiesSortingOrder["TITLE_DESC"] = "TITLE_DESC";
    EntitiesSortingOrder["UPDATED_ASC"] = "UPDATED_ASC";
    EntitiesSortingOrder["UPDATED_DESC"] = "UPDATED_DESC";
})(EntitiesSortingOrder = exports.EntitiesSortingOrder || (exports.EntitiesSortingOrder = {}));
var ExternalVideoSource;
(function (ExternalVideoSource) {
    ExternalVideoSource["FACEBOOK"] = "FACEBOOK";
    ExternalVideoSource["VIMEO"] = "VIMEO";
    ExternalVideoSource["YOUTUBE"] = "YOUTUBE";
})(ExternalVideoSource = exports.ExternalVideoSource || (exports.ExternalVideoSource = {}));
var MediaStatus;
(function (MediaStatus) {
    MediaStatus["FAILED"] = "FAILED";
    MediaStatus["IN_PROGRESS"] = "IN_PROGRESS";
    MediaStatus["IN_QUEUE"] = "IN_QUEUE";
    MediaStatus["PREVIEW_READY"] = "PREVIEW_READY";
    MediaStatus["READY"] = "READY";
})(MediaStatus = exports.MediaStatus || (exports.MediaStatus = {}));
var MutationStatus;
(function (MutationStatus) {
    MutationStatus["ERROR"] = "ERROR";
    MutationStatus["SUCCESS"] = "SUCCESS";
})(MutationStatus = exports.MutationStatus || (exports.MutationStatus = {}));
var SettingsDefaultPricingType;
(function (SettingsDefaultPricingType) {
    SettingsDefaultPricingType["RENT"] = "RENT";
    SettingsDefaultPricingType["SALE"] = "SALE";
})(SettingsDefaultPricingType = exports.SettingsDefaultPricingType || (exports.SettingsDefaultPricingType = {}));
var VideoCardPosition;
(function (VideoCardPosition) {
    VideoCardPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    VideoCardPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    VideoCardPosition["TOP_LEFT"] = "TOP_LEFT";
    VideoCardPosition["TOP_RIGHT"] = "TOP_RIGHT";
})(VideoCardPosition = exports.VideoCardPosition || (exports.VideoCardPosition = {}));
var VideoCardTargetExternalType;
(function (VideoCardTargetExternalType) {
    VideoCardTargetExternalType["FACEBOOK"] = "FACEBOOK";
    VideoCardTargetExternalType["TWITTER"] = "TWITTER";
    VideoCardTargetExternalType["YOUTUBE"] = "YOUTUBE";
})(VideoCardTargetExternalType = exports.VideoCardTargetExternalType || (exports.VideoCardTargetExternalType = {}));
var VideoCardType;
(function (VideoCardType) {
    VideoCardType["CHANNEL"] = "CHANNEL";
    VideoCardType["CUSTOM"] = "CUSTOM";
    VideoCardType["PRODUCT"] = "PRODUCT";
    VideoCardType["RECENT_VIDEO"] = "RECENT_VIDEO";
    VideoCardType["SOCIAL"] = "SOCIAL";
    VideoCardType["VIDEO"] = "VIDEO";
})(VideoCardType = exports.VideoCardType || (exports.VideoCardType = {}));
var VideoSource;
(function (VideoSource) {
    VideoSource["COMPUTER"] = "COMPUTER";
    VideoSource["DROPBOX"] = "DROPBOX";
    VideoSource["FACEBOOK"] = "FACEBOOK";
    VideoSource["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    VideoSource["LIVE"] = "LIVE";
    VideoSource["VIMEO"] = "VIMEO";
    VideoSource["YOUTUBE"] = "YOUTUBE";
})(VideoSource = exports.VideoSource || (exports.VideoSource = {}));
var VideoStatus;
(function (VideoStatus) {
    VideoStatus["DRAFT"] = "DRAFT";
    VideoStatus["FAILED"] = "FAILED";
    VideoStatus["INIT"] = "INIT";
    VideoStatus["IN_PROGRESS"] = "IN_PROGRESS";
    VideoStatus["OVER_QUOTA"] = "OVER_QUOTA";
    VideoStatus["VISIBLE"] = "VISIBLE";
})(VideoStatus = exports.VideoStatus || (exports.VideoStatus = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=globalTypes.js.map